import { gql } from '@apollo/client';
import {
  SH_RESERVATION_FRAGMENT,
  SH_RESERVATION_BASE_FRAGMENT,
  ERROR_FRAGMENT,
} from './fragments.js';

export const GET_SH_RESERVATIONS = gql`
  query GetShReservations($fieldId: ID, $status: [ReservationStatus!], $from: Date, $to: Date) {
    MDB {
      id
      _SH_ {
        id
        reservations(fieldId: $fieldId, status: $status, from: $from, to: $to) {
          items {
            ...ShReservationFields
          }
        }
      }
    }
  }
  ${SH_RESERVATION_FRAGMENT}
`;

export const GET_SH_RESERVATIONS_PAGINATED = gql`
  query GetShReservationsPaginated(
    $fieldId: ID
    $status: [ReservationStatus!]
    $from: Date
    $to: Date
    $page: Int
    $limit: Int
  ) {
    MDB {
      id
      _SH_ {
        id
        reservationsPaginated(
          fieldId: $fieldId
          status: $status
          from: $from
          to: $to
          page: $page
          limit: $limit
        ) {
          items {
            ...ShReservationFields
          }
          pageInfo {
            currentPage
            totalPages
            totalItems
            hasNextPage
            hasPreviousPage
          }
        }
      }
    }
  }
  ${SH_RESERVATION_FRAGMENT}
`;

export const GET_SH_RESERVATION = gql`
  query GetShReservation($id: ID!) {
    MDB {
      id
      _SH_ {
        id
        reservation(id: $id) {
          ...ShReservationBaseFields
        }
      }
    }
  }
  ${SH_RESERVATION_BASE_FRAGMENT}
`;

export const CREATE_SH_RESERVATION = gql`
  mutation CreateShReservation($input: _SH_RES_CreateReservationInput!) {
    _SH_RES_createReservation(input: $input) {
      ok
      error {
        ...ErrorFields
      }
      reservation {
        ...ShReservationBaseFields
      }
    }
  }
  ${SH_RESERVATION_BASE_FRAGMENT}
  ${ERROR_FRAGMENT}
`;

export const UPDATE_SH_RESERVATION = gql`
  mutation UpdateShReservation($id: ID!, $input: _SH_RES_UpdateReservationInput!) {
    _SH_RES_updateReservation(id: $id, input: $input) {
      ok
      error {
        ...ErrorFields
      }
      reservation {
        ...ShReservationBaseFields
      }
    }
  }
  ${SH_RESERVATION_BASE_FRAGMENT}
  ${ERROR_FRAGMENT}
`;

export const DELETE_SH_RESERVATION = gql`
  mutation DeleteShReservation($id: ID!) {
    _SH_RES_deleteReservation(id: $id) {
      ok
      error {
        ...ErrorFields
      }
      reservation {
        ...ShReservationBaseFields
      }
    }
  }
  ${SH_RESERVATION_BASE_FRAGMENT}
  ${ERROR_FRAGMENT}
`;

export const RESERVATION_UPDATED_SUBSCRIPTION = gql`
  subscription ReservationUpdated($clientId: String!, $fieldId: ID) {
    _SH_RES_reservationUpdated(clientId: $clientId, fieldId: $fieldId) {
      ...ShReservationFields
    }
  }
  ${SH_RESERVATION_FRAGMENT}
`;

export const RESERVATION_CREATED_SUBSCRIPTION = gql`
  subscription ReservationCreated($clientId: String!, $fieldId: ID) {
    _SH_RES_reservationCreated(clientId: $clientId, fieldId: $fieldId) {
      ...ShReservationFields
    }
  }
  ${SH_RESERVATION_FRAGMENT}
`;

export const RESERVATION_DELETED_SUBSCRIPTION = gql`
  subscription ReservationDeleted($clientId: String!, $fieldId: ID) {
    _SH_RES_reservationDeleted(clientId: $clientId, fieldId: $fieldId)
  }
`;
